import styled, { css } from 'styled-components'

const Container = styled.div`
${({ theme }) => {
        const { device } = theme;
        return css`
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            text-align: center;
            max-width: 100vw;
            @media ${device.tabletM} {
                display: grid;
                grid-template-columns: 43vw 1fr;
                align-items: center;
                min-height: 100vh;
            }
        `;
    }}
`;

const Background = styled.div`
${({ theme }) => {
        const { device } = theme;
        return css`
        position: absolute;
            @media ${device.tabletM} {
                transform: rotate(90deg);
                position: absolute;
                top: 0%;
                left: -26%;
                // height: 69vh;
            }
        `;
    }}
`;

const MapContainer = styled.div`
${({ theme }) => {
        return css`
            position: absolute;
            width: 100vw;
            height: 100vh;
            z-index: -2;
        `;
    }}
`;


const HeaderContainer = styled.div`
${({ theme }) => {
        const { device } = theme;
        return css`
            @media ${device.tabletM} {
                grid-column: 2/3;
                grid-row: 1/3;
            }
        `;
    }}
`;

const MenuContainer = styled.div`
${({ theme }) => {
        const { device } = theme;
        return css`
            @media ${device.tabletM} {
                grid-column: 1/2;
                grid-row: 1/3;
            }
        `;
    }}
`;

const styledComponents = { Container, Background, MapContainer, HeaderContainer, MenuContainer };

export default styledComponents;